import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, ShieldCheck, Award, Users, HeartHandshake, GraduationCap, Sparkles } from "lucide-react";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import Partners from "@/components/Partners";
import { SITE, waHref } from "@/data/site";

const TEAM = [
  {
    slug: "sevda-karatas",
    name: "Sevda Karataş",
    title: "Usta Öğretici — Uzman Estetisyen",
    subtitle: "Cilt Bakımı & Lazer Epilasyon Uzmanı",
    image: "/upload/team/sevda-karatas.jpg",
    imageSquare: "/upload/team/sevda-karatas-square.jpg",
    tags: ["Cilt Bakımı", "Lazer Epilasyon", "Usta Öğretici"],
    lead: "Uzun yılların deneyimini bir annenin sıcaklığıyla harmanlayan uzman estetisyen.",
    bio: [
      "Sevda Karataş, MEB onaylı Usta Öğretici sertifikasına ve MYK Epilasyon Uzmanı Seviye 4 Belgesi'ne sahip uzman estetisyen kimliğiyle MediEste kadrosunda yer alıyor. Uzun yılların pratiğini titiz bir yaklaşımla birleştirir; cilt bakımı ve lazer epilasyon uygulamalarını sanki bir aile ferdinin cildine dokunuyormuşçasına özenle yapar.",
      "Her misafirini ilk seansta enine boyuna tanır; ciltle konuşan bir usta gibi doğru protokolü, doğru ürünü ve doğru cihaz ayarlarını sizin için seçer. HydraFacial, kolajen bakımı, algae mask, kimyasal peeling ve dermokozmetik seçimlerinde deneyimi ve şefkati bir arada sunar.",
      "Lazer epilasyonda ise cilt tipi, tüy yapısı ve hormonal geçmişinize göre kişiselleştirilmiş bir seans planı çıkarır; işlemi ağrısız, güvenli ve sonuç odaklı yönetir. Konforunuz onun için en az sonuç kadar önemlidir — bu yüzden ilk seanstan itibaren kendinizi bir evin, bir annenin yakınlığında hissedersiniz."
    ],
    highlights: [
      "MEB Onaylı Usta Öğretici Sertifikası",
      "MYK Epilasyon Uzmanı — Seviye 4 Belgesi",
      "Yılların Cilt Bakımı Pratiği",
      "Lazer Epilasyon Sertifikalı Uygulayıcı"
    ],
    waMessage: "Sevda Karataş ile cilt bakımı / lazer epilasyon için randevu almak istiyorum."
  },
  {
    slug: "serdar-ceylan",
    name: "Serdar Ceylan",
    title: "Podolog",
    subtitle: "Uzman Podolog",
    image: "/upload/team/serdar-ceylan.jpg",
    imageSquare: "/upload/team/serdar-ceylan-square.jpg",
    tags: ["Podoloji", "Medikal Ayak Bakımı"],
    lead: "Sağlık alanında kendi ekosistemini oluşturmuş; podoloji ile estetik uygulamalarını bir arada sunan öncü isimlerden.",
    bio: [
      "Ankara Üniversitesi Podoloji Programı mezunu olan Podolog Serdar Ceylan, sağlık alanında kendi ekosistemini oluşturarak MediEste, MediPodo, AyakTakip ve PediZone markalarını hayata geçirmiştir.",
      "Batık tırnak, nasır, plantar siğil, onikoliz ve tırnak mantarı gibi ayak sağlığı problemlerine yönelik bilimsel ve etkili çözümler sunmaktadır. Aynı zamanda Usta Öğretici ve Estetisyen unvanlarına sahip olan Serdar Ceylan, podoloji ile estetik uygulamalarını bir araya getirerek bütüncül bir hizmet anlayışı benimsemektedir.",
      "AyakTakip mobil uygulamasının geliştiricisi ve PediZone ayak sağlığı ürünlerinin üreticisi olan Serdar Ceylan, MediEste çatısı altında estetik ve podolojik hizmetleri tek merkezde buluşturarak ayak sağlığı ve bakımında kapsamlı çözümler sunmaktadır.",
      "Klinik çalışmalarında hijyen, sterilizasyon ve bilimsel yaklaşımı ön planda tutan Serdar Ceylan, her danışanının ihtiyaçlarını ayrıntılı şekilde değerlendirerek kişiye özel bakım ve tedavi planları oluşturmaktadır."
    ],
    highlights: [
      "Ankara Üniversitesi — Podoloji Mezunu",
      "PediZone Kurucusu",
      "AyakTakip Mobil Uygulaması Geliştiricisi",
      "MediEste ve MediPodo Markalarının Kurucusu",
      "Usta Öğretici ve Estetisyen"
    ],
    waMessage: "Serdar Ceylan ile podoloji için danışma randevusu almak istiyorum."
  },
  {
    slug: "selin-salur",
    name: "Selin Salur",
    title: "Master Nail Technician",
    subtitle: "Protez Tırnak & Medikal Pedikür Uzmanı",
    image: "/upload/team/selin-salur.webp",
    imageSquare: "/upload/team/selin-salur-square.webp",
    tags: ["Protez Tırnak", "Medikal Pedikür", "Rus Manikür"],
    lead: "Modern protez tırnak teknikleri, tırnak koruma uygulamaları ve medikal pedikür alanında profesyonel hizmet vermektedir.",
    bio: [
      "Mesleki gelişimini sürekli eğitim anlayışıyla sürdüren Selin Salur; tırnak yapısı, ayak ve tırnak bakımı ile ilgili podolojik eğitim ve seminerlere düzenli olarak katılmakta, edindiği bilgileri uygulama teknikleriyle bir araya getirmektedir.",
      "Özellikle detaylı işçilik, doğal görünüm ve dayanıklılığın ön planda olduğu Rus manikür ve Rus tırnak tekniklerine ilgi duymakta; bu alandaki yeni yöntemleri, uygulama tekniklerini ve sektörel gelişmeleri yakından takip etmektedir.",
      "Uygulamalarında yalnızca estetik görünümü değil, doğal tırnak yapısının korunmasını ve doğru bakım alışkanlıklarının desteklenmesini de önemsemektedir. Kişinin tırnak yapısına ve ihtiyacına uygun uygulama planlamasıyla temiz, özenli ve doğal sonuçlar elde etmeyi hedeflemektedir."
    ],
    highlights: [
      "Protez Tırnak",
      "Tırnak Koruma Uygulamaları",
      "Medikal Pedikür",
      "Rus Manikür Teknikleri",
      "Doğal Tırnak Bakımı"
    ],
    waMessage: "Selin Salur ile protez tırnak ve medikal pedikür için randevu almak istiyorum."
  },
  {
    slug: "semih-ceylan",
    name: "Semih Ceylan",
    title: "Epilasyon Uzmanı",
    subtitle: "Erkek Lazer Epilasyon Uzmanı — MYK Seviye 4",
    image: "/upload/team/semih-ceylan.webp",
    imageSquare: "/upload/team/semih-ceylan.webp",
    tags: ["Erkek Lazer Epilasyon", "Seans Planlaması", "MYK Seviye 4"],
    lead: "Erkek lazer epilasyon uygulamaları alanında MYK Seviye 4 Mesleki Yeterlilik Belgesi ile profesyonel hizmet sunmaktadır.",
    bio: [
      "Erkek lazer epilasyon uygulamaları alanında hizmet veren Semih Ceylan, MYK Lazer Epilasyon Seviye 4 Mesleki Yeterlilik Belgesi sahibidir.",
      "Uygulama öncesinde kişinin kıl yapısı, kıl yoğunluğu, uygulama yapılacak bölge ve cilt özelliklerini dikkate alarak sürecin planlanmasına önem vermektedir. Her danışanın kıl yapısının ve lazer uygulamalarına verdiği yanıtın farklı olabileceği yaklaşımıyla, standart bir uygulama yerine kişiye ve bölgeye göre ilerleyen bir seans takibi yürütmektedir.",
      "Danışanların süreci rahat sürdürebilmesi için kişiye özel seans takibi ve esnek çalışma saatleri sunmakta; düzenli, dikkatli ve istekli çalışma anlayışıyla uygulamaların planlı şekilde devam etmesini sağlamaktadır."
    ],
    highlights: [
      "MYK Lazer Epilasyon Seviye 4 Belgesi",
      "Kıl Tipi ve Yoğunluk Değerlendirmesi",
      "Kişiye Özel Seans Planlaması",
      "Düzenli Seans ve Süreç Takibi"
    ],
    waMessage: "Semih Ceylan ile erkek lazer epilasyon için randevu almak istiyorum."
  }
];

function TeamMemberSection({ member, reverse = false }) {
  return (
    <section id={member.slug} className={`py-14 md:py-16 ${reverse ? "bg-[#F5F7FA]" : "bg-white"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid md:grid-cols-5 gap-10 md:gap-14 items-center`}>
          <div className={`md:col-span-2 relative ${reverse ? "md:order-2" : ""}`}>
            <div className="absolute -top-4 -left-4 h-24 w-24 md:h-32 md:w-32 rounded-full bg-gradient-to-br from-[#A8C520]/25 to-[#3F7A2E]/15 pointer-events-none blur-2xl"></div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <picture>
                <source srcSet={member.image.replace(/\.jpg$/, ".webp")} type="image/webp" />
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.title}`}
                  width="600"
                  height="750"
                  loading="lazy"
                  decoding="async"
                  className="w-full aspect-[4/5] object-cover"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B33]/40 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-[10px] tracking-[0.22em] uppercase font-bold opacity-90">{member.title}</p>
                <p className="font-display text-white text-2xl md:text-3xl leading-tight">{member.name}</p>
              </div>
            </div>
          </div>
          <div className={`md:col-span-3 ${reverse ? "md:order-1" : ""}`}>
            <p className="chip-green mb-4">{member.subtitle}</p>
            <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] leading-[1.05] mb-4 tracking-tight">{member.name}</h2>
            <p className="text-[#0B1B33] text-base md:text-lg font-medium leading-relaxed mb-5">{member.lead}</p>
            {member.bio.map((p, i) => (
              <p key={i} className="text-[#4B5A6E] leading-relaxed mb-4">{p}</p>
            ))}
            <ul className="grid sm:grid-cols-2 gap-2.5 mt-6 mb-8">
              {member.highlights.map((h, i) => (
                <li key={i} className="flex gap-2.5 text-sm text-[#4B5A6E]">
                  <ShieldCheck size={16} className="text-[#4F8B2A] shrink-0 mt-0.5" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <a href={waHref(member.waMessage)} target="_blank" rel="noreferrer" className="btn-mint">
                <MessageCircle size={14} /> Uzmana Ulaş
              </a>
              <Link to="/hizli-randevu" className="btn-outline">
                <Sparkles size={14} /> Randevu Al
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <SEO
        title="Hakkımızda"
        description="MediEste Estetik & Güzellik — Ankara Bağlıca'da kadın ve erkek misafirlerimize güzellik, cilt bakımı, lazer epilasyon ve medikal ayak bakımı hizmetleri sunan uzman merkezimizi tanıyın."
        path="/hakkimizda"
      />
      <section className="pt-32 pb-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: "Hakkımızda" }]} />
      </section>

      <section id="ekibimiz" className="pb-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="chip-green mb-4 mx-auto">Ekibimiz</p>
          <h1 className="font-display text-4xl md:text-6xl text-[#0B1B33] leading-[1.05] mb-5 tracking-tight">Emin ellerdesiniz.</h1>
          <p className="text-[#4B5A6E] leading-relaxed">
            MediEste, yılların pratiği ve titiz bir bilimsel yaklaşımla; podoloji ve estetik alanında güvenle tercih edilen uzman kadrosuyla sizi karşılıyor.
          </p>
        </div>
      </section>

      <TeamMemberSection member={TEAM[0]} />
      <TeamMemberSection member={TEAM[1]} reverse />
      <TeamMemberSection member={TEAM[2]} />
      <TeamMemberSection member={TEAM[3]} reverse />

      <section className="pb-24 pt-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <div className="reveal-up">
            <p className="chip mb-4">Hikayemiz</p>
            <h2 className="font-display text-4xl md:text-6xl text-[#0B1B33] leading-[1.05] mb-8 tracking-tight">Güzelliğe adanmış <br/>bir yolculuk.</h2>
            <p className="text-[#4B5A6E] leading-relaxed mb-4">
              MediEste Estetik &amp; Güzellik, Ankara Bağlıca'da kişisel bakım ve güzellik alanında uzmanlaşmış bir merkezdir. Hem kadın hem erkek misafirlerimize hitap eden geniş hizmet yelpazemizle sağlığınızı ve güzelliğinizi ön planda tutuyoruz.
            </p>
            <p className="text-[#4B5A6E] leading-relaxed mb-4">
              Deneyimli ve eğitimli ekibimiz; cilt bakımı, lazer epilasyon, bölgesel zayıflama, kalıcı makyaj, ipek kirpik, protez tırnak ve medikal ayak bakımı gibi çeşitli hizmetleri titiz bir profesyonellikle sunar.
            </p>
            <p className="text-[#4B5A6E] leading-relaxed">
              Hijyen, güvenlik ve müşteri memnuniyeti bizim için her zaman ön plandadır. Modern teknikler ve profesyonel ürünlerle sizlere en iyi deneyimi yaşatmayı hedefliyoruz.
            </p>
          </div>
          <div className="relative">
            <div className="w-full aspect-[4/5] rounded-2xl shadow-xl overflow-hidden bg-gradient-to-br from-[#F5F7FA] via-white to-[#EFF3EE] flex items-center justify-center">
              <img src="/upload/images/hakkimizda-gorsel.jpg" alt="MediEste Estetik & Güzellik" loading="lazy" className="w-full h-full object-contain" />
            </div>
            <div className="absolute -bottom-6 -right-6 md:-right-10 border-2 border-[#4F8B2A] h-28 w-28 md:h-44 md:w-44 pointer-events-none rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 h-16 w-16 md:h-24 md:w-24 rounded-full bg-[#6CA320]/10 pointer-events-none"></div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#F5F7FA] border-y border-[#E5EAF0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14 max-w-3xl mx-auto">
            <p className="chip mb-3 mx-auto">Değerlerimiz</p>
            <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] tracking-tight">Neden MediEste?</h2>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: ShieldCheck, title: "Klinik Hijyen", desc: "Steril ortam ve tek kullanımlık ekipmanlarla güvenli uygulama." },
              { icon: Award, title: "MYK Belgeli", desc: "Mesleki Yeterlilik Kurumu onaylı uzman kadro." },
              { icon: Users, title: "Uzman Ekip", desc: "Podoloji, dermokozmetik ve estetik uzmanlarımız." },
              { icon: HeartHandshake, title: "Kişiye Özel", desc: "Cilt tipinize ve ihtiyacınıza özel bakım protokolleri." },
            ].map((v, i) => (
              <div key={i} className="text-center bg-white p-8 rounded-2xl border border-[#E5EAF0] hover:border-[#10B981]/40 hover:shadow-lg transition-all">
                <div className="h-14 w-14 rounded-2xl bg-[#10B981]/10 flex items-center justify-center text-[#10B981] mx-auto mb-4"><v.icon size={26} /></div>
                <h3 className="font-display text-xl text-[#0B1B33] mb-2 font-medium">{v.title}</h3>
                <p className="text-sm text-[#4B5A6E] leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Partners />
    </>
  );
}
